module.exports = global["Favorites"] = require("-!/var/www/ridewithgps.com/releases/20261103180724/node_modules/babel-loader/lib/index.js?{\"presets\":[\"es2015\"]}!/var/www/ridewithgps.com/releases/20261103180724/node_modules/eslint-loader/index.js!./favorites.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Favorites!./public/javascripts/favorites.js-exposed
// module id = 138
// module chunks = 0